/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-dialog-content[_ngcontent-%COMP%]{height:280px;display:flex;flex-direction:column}mat-dialog-actions[_ngcontent-%COMP%]{justify-content:flex-end}mat-slide-toggle[_ngcontent-%COMP%]{margin-bottom:10px}.error[_ngcontent-%COMP%]{color:red;font-weight:bolder}"];
export { styles as styles };
